export const DIPENDENTE_ANYONE_OPTION = '__anyone__';